var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
export var DELAYS = {
    0: 0,
    1: 250,
    2: 500,
    3: 750,
    4: 1000,
    5: 1250,
    6: 1500,
    7: 1750,
    8: 2000,
    9: 2250
};
var DURATION = '500ms';
export function fadeInAnimation(delay) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @keyframes fadeIn {\n      from {\n        opacity: 0;\n      }\n      to {\n        opacity: 1;\n      }\n    }\n\n    opacity: 0;\n    animation: ", " linear ", "ms 1 both fadeIn;\n  "], ["\n    @keyframes fadeIn {\n      from {\n        opacity: 0;\n      }\n      to {\n        opacity: 1;\n      }\n    }\n\n    opacity: 0;\n    animation: ", " linear ", "ms 1 both fadeIn;\n  "])), DURATION, delay);
}
var templateObject_1;
